export default httpClient => ({
    save: async ({ plano_pagarme_id, cliente_pagarme_id, forma_pagamento, number, holder_name, exp_month, exp_year, cvv, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/assinaturas', {
            plano_pagarme_id,
            cliente_pagarme_id,
            forma_pagamento,
            number,
            holder_name,
            exp_month,
            exp_year,
            cvv
        }, { headers })
        return {
            data: response.data,
        }
    },
   /* update: async ({ id, nome, email, password, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.patch('/contatos/' + id, {
            id,
            nome,
            email,
            password
        }, { headers });
        return {
            data: response.data
        }
    },*/

    saldoAtual: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/obter-saldo', { headers });
        return {
            data: response.data
        }
    },

    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/faturas/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/faturas', { headers });
        return { data: response.data }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/assinaturas/' + id, { headers });
        return {
            data: response
        }
    },
});